import Vue from 'vue'
import Vuex from 'vuex'
import utils from "../common/utils.js";

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        //用户token
        token: "",
        //用户基础信息
        baseInfo: {
            userId: "",
            userName: "",
        },
    },
    mutations: {
        //设置stat的值
        set: function (state, data) {
            let key = data["key"];
            let val = data["val"];
            let keyArr = key.split('.');

            if (utils.isEmpty(keyArr)) {
                return;
            }

            utils.setObjVal(state, key, val);
        },
        setBaseInfo(state,baseInfo){
            state.baseInfo = baseInfo
        },
        setToken(state,token){
            state.token = token
        }
    },
    actions: {},
    modules: {}
})
